module.exports = __webpack_public_path__ + "assets/img/teacher (5).9ede7128.png";